import { useSurveyContext } from '../../../_store'

const useSingleSelect = ({ component, step }) => {
  const { state, dispatch } = useSurveyContext()
  const { formData } = state.pages[`step_${step}`]
  const { slug } = component

  const handleSelect = (option) => {
    if (formData[slug] !== option) {
      dispatch({
        type: 'setAnswer',
        payload: {
          [slug]: [option.slug]
        }
      })
    }
  }

  const isSelected = (option) => {
    return formData[slug] && formData[slug].includes(option.slug)
  }

  return [isSelected, handleSelect]
}

export default useSingleSelect
